var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import commonImageUploader from '../../components/console-common/common-image-uploader.vue';
import colorSelect from '../../components/console-common/color-select.vue';
import * as constant from '../../constant/driver-type';
import { contractStatusOptions } from '../../constant/common-type';
import moment from 'moment';
import textarea from '../../components/console-common/common-textarea.vue';
import searchInput from '../../components/console-common/search-input.vue';
import eventBus from '../../utils/fresh-table';
import { mapState } from 'vuex';
import { checkName } from '../../utils/common-utils';
export default Vue.extend({
    created: function () {
        this.spanWidth = this.type === 'create' ? 8 : 12;
        if (this.type === 'edit') {
            this.ruleForm = Object.assign({}, this.driverDetail);
            this.imageConfig.imageList[0].fileList = this.ruleForm.idNoPhotos;
            this.imageConfig.imageList[1].fileList = this.ruleForm.drivingLicencePhotos;
            this.imageConfig.imageList[2].fileList = this.ruleForm.onlineLicensePhotos;
            if (this.driverDetail.drivingLicenceValidityStart &&
                this.driverDetail.drivingLicenceValidityEnd) {
                this.drivingLicenceValidity = [
                    moment(this.driverDetail.drivingLicenceValidityStart).format('YYYY-MM-DD'),
                    moment(this.driverDetail.drivingLicenceValidityEnd).format('YYYY-MM-DD'),
                ];
            }
        }
    },
    components: {
        'el-image-uploader': commonImageUploader,
        'el-color-select': colorSelect,
        'el-self-textarea': textarea,
        'el-search-input': searchInput,
    },
    data: function () {
        return {
            spanWidth: 8,
            imageObj: {},
            drivingLicenceValidity: [],
            constant: constant,
            contractStatusOptions: contractStatusOptions,
            ruleForm: {
                drivingLicenceValidityType: false,
            },
            addCompanyConfig: {
                name: {
                    type: '',
                },
            },
            rules: {
                driverName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { validator: checkName, trigger: 'blur' },
                ],
                operator: [{ validator: checkName, trigger: 'blur' }],
                idNo: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        trigger: 'blur',
                        message: '身份证格式不正确',
                    },
                ],
                sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^(00|11|13|14|15|16|17|18|19)[0-9]{9}$/,
                        trigger: 'blur',
                        message: '手机号格式不正确',
                    },
                ],
                contact: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { max: 50, message: '最多输入50个字', trigger: 'blur' },
                ],
                address: [{ max: 100, message: '最多输入100个字', trigger: 'blur' }],
                emergencyContactMobile: [
                    { max: 50, message: '最多输入500个字', trigger: 'blur' },
                ],
                remark: [{ max: 100, message: '最多输入100个字', trigger: 'blur' }],
                emergencyContactName: [{ validator: checkName, trigger: 'blur' }],
            },
            imageConfig: {
                url: '/proxy/vehicle/file/file/upload',
                imageList: [
                    {
                        // 配置照片列表
                        limit: 2,
                        title: '身份证照片',
                        key: 'idNoPhotos',
                        span: 12,
                        fileList: [],
                    },
                    {
                        limit: 2,
                        title: '驾驶证',
                        key: 'drivingLicencePhotos',
                        span: 12,
                        fileList: [],
                    },
                    {
                        limit: 1,
                        title: '网约车人证',
                        key: 'onlineLicensePhotos',
                        span: 24,
                        fileList: [],
                    },
                ],
            },
        };
    },
    computed: __assign({}, mapState('driver', ['driverDetail'])),
    methods: {
        submitForm: function (ruleForm) {
            var _this = this;
            // 提交form表单
            var url = this.type === 'create' ? '/driver/upload/single' : '/driver/update';
            this.$refs.ruleForm.validate(function (valid) {
                if (valid) {
                    _this.$refs.imageUpload.forEach(function (item) {
                        var key = item.imageObj.key;
                        _this.imageObj[key] = item._data.uploadKeys.join(',');
                    });
                    var _a = _this.ruleForm, driverName = _a.driverName, idNo = _a.idNo, sex = _a.sex, mobile = _a.mobile, contact = _a.contact, attachCompany = _a.attachCompany, address = _a.address, emergencyContactName = _a.emergencyContactName, emergencyContactMobile = _a.emergencyContactMobile, drivingLicenceType = _a.drivingLicenceType, operator = _a.operator, drivingLicenceValidityType = _a.drivingLicenceValidityType, remark = _a.remark;
                    var drivingLicenceValidity = _this.drivingLicenceValidity;
                    var params = __assign({ driverName: driverName,
                        idNo: idNo,
                        sex: sex,
                        mobile: mobile,
                        contact: contact,
                        attachCompany: attachCompany,
                        address: address,
                        emergencyContactName: emergencyContactName,
                        emergencyContactMobile: emergencyContactMobile,
                        drivingLicenceType: drivingLicenceType,
                        operator: operator,
                        drivingLicenceValidityType: drivingLicenceValidityType,
                        remark: remark, drivingLicenceValidityStart: drivingLicenceValidity
                            ? moment(drivingLicenceValidity[0]).format('YYYY-MM-DD')
                            : '', drivingLicenceValidityEnd: drivingLicenceValidity
                            ? moment(drivingLicenceValidity[1]).format('YYYY-MM-DD')
                            : '' }, _this.imageObj);
                    if (_this.type === 'edit') {
                        params = Object.assign({}, params, {
                            driverCode: _this.driverDetail.driverCode,
                        });
                    }
                    _this.$request({
                        url: "/proxy/vehicle/driver" + url,
                        method: 'post',
                        data: params,
                    }).then(function (res) {
                        if (!res.errorCode) {
                            if (_this.type === 'edit') {
                                _this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                });
                                eventBus.$emit('freshTable');
                                _this.$store.commit('driver/update', {
                                    showDriverEditDialog: false,
                                });
                            }
                            else {
                                _this.$confirm('', '', {
                                    message: '<p class="title">司机导入成功</p><p class="text">可前往司机管理-司机查询 查看</p>',
                                    dangerouslyUseHTMLString: true,
                                    confirmButtonText: '前往查看',
                                    cancelButtonText: '取消',
                                    type: 'warning',
                                    showClose: false,
                                })
                                    .then(function () {
                                    _this.$router.push({
                                        path: '/console/driver/query',
                                    });
                                })
                                    .catch(function () {
                                    _this.drivingLicenceValidity = [];
                                    _this.$refs.ruleForm.resetFields();
                                    eventBus.$emit('removeImage');
                                });
                            }
                        }
                        else {
                            _this.$message.error(res.errorMsg);
                        }
                    });
                }
                else {
                    return false;
                }
            });
        },
    },
    props: {
        type: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
});
